import { Tile, isSuited, tileNumber } from './tiles';

/** 표시패 다음 패가 도라. 수패 9→1 순환, 바람 北→東, 삼원 中→白. */
export function doraFromIndicator(indicator: Tile): Tile {
  if (isSuited(indicator)) {
    const n = tileNumber(indicator);          // 1..9
    const base = indicator - (n - 1);         // 수패 시작(0/9/18)
    return base + (n % 9);                     // 9 → base+0(=1), else base+n
  }
  if (indicator <= 30) {                       // 바람 27..30
    return indicator === 30 ? 27 : indicator + 1;
  }
  return indicator === 33 ? 31 : indicator + 1; // 삼원 31..33
}

/** 손패 안의 도라 총 개수. */
export function countDora(tiles: readonly Tile[], indicators: readonly Tile[]): number {
  const doras = indicators.map(doraFromIndicator);
  let count = 0;
  for (const t of tiles) for (const d of doras) if (t === d) count++;
  return count;
}
